import { Component, OnInit } from '@angular/core';
import { BaseModalUpdateComponent, ModalContainerService, ModalService } from 'yt-ng-framework';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PodVrstaDokumenta } from '../podvrste-dokumenta/podvrste-dokumenta';

@Component({
  selector: 'yt-podvrste-dokumenta-modal-update',
  templateUrl: './podvrste-dokumenta-modal-update.component.html'
})
export class PodVrsteDokumentaModalUpdateComponent extends BaseModalUpdateComponent<PodVrstaDokumenta> implements OnInit {

  constructor(
    protected modalContainerService: ModalContainerService<PodVrstaDokumenta>,
    protected activeModal: NgbActiveModal,
    protected modalService: ModalService
  ) {
    super(modalContainerService, activeModal,modalService);
  }

  ngOnInit() {
  }

}
